import React from "react";
import { Box, Typography, Stack, Button, alpha, useTheme } from "@mui/material";
import { PhoneInTalk, Add as AddIcon } from "@mui/icons-material";

const VisitCallHeader = ({ onCreate }) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mb: 3 }}
    >
      <Box>
        <Stack direction="row" spacing={1} alignItems="center">
          <PhoneInTalk
            sx={{ color: theme.palette.primary.main, fontSize: 22 }}
          />
          <Typography
            variant="h6"
            fontWeight={900}
            sx={{ color: "#1e293b", letterSpacing: -0.5 }}
          >
            Call of Visit Plans
          </Typography>
        </Stack>
        <Typography variant="caption" fontWeight={600} color="text.secondary">
          Short scheduled care calls with specific support instructions
        </Typography>
      </Box>

      <Button
        onClick={onCreate}
        variant="contained"
        disableElevation
        startIcon={<AddIcon sx={{ fontSize: 20 }} />}
        sx={{
          textTransform: "none",
          fontWeight: 700,
          fontSize: "0.85rem",
          letterSpacing: 0.2,
          borderRadius: "10px",
          px: 2.5,
          py: 1,
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          boxShadow: `0 6px 16px ${alpha(theme.palette.primary.main, 0.35)}`,
          transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
            boxShadow: `0 10px 22px ${alpha(theme.palette.primary.main, 0.45)}`,
            transform: "translateY(-2px)",
          },
          "&:active": {
            transform: "translateY(0)",
            boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.35)}`,
          },
        }}
      >
        Create Visit
      </Button>
    </Stack>
  );
};

export default VisitCallHeader;